export default {
  setReports (state, payload) {
    state.reports = payload
  }
}
